import { c as _c } from "react/compiler-runtime";
import { Category } from '@sbt-web/category-utils';
import { FilterURI, type CompositeFilter } from '@sbt-web/network/types';
import { extractDependencyValues } from '@/shared/helpers/DataSourceHelpers';
import type { FiltersStore } from '@/tools/search/getFiltersStore';
import { AdTypeSelector, BoolSelector, ListSelector, QSOSelector, RangeSelector, ShippableOnlySelector, FilterableListSelector } from '../Elements/Filters';
import { UrgentSelector } from '../Elements/Filters/UrgentSelector';
import { CommonFilterProps } from '../Elements/Filters/common/types';
type Props = CommonFilterProps & {
  activeFilters: {
    [key: string]: string;
  };
  category: Category;
  filter: CompositeFilter;
  filterStore: FiltersStore;
  onFilterSelected: (key: string, value?: string, label?: string) => void;
  trackSearchConversion: () => void;
};
export const Filter = t0 => {
  const $ = _c(43);
  const {
    activeFilters,
    category,
    filter,
    filterStore,
    showBadgeNew,
    onFilterSelected,
    trackSearchConversion
  } = t0;
  switch (filter.uri) {
    case FilterURI.ItemShippable:
      {
        let t1;
        if ($[0] !== showBadgeNew || $[1] !== trackSearchConversion) {
          t1 = <ShippableOnlySelector showBadgeNew={showBadgeNew} trackSearchConversion={trackSearchConversion} />;
          $[0] = showBadgeNew;
          $[1] = trackSearchConversion;
          $[2] = t1;
        } else {
          t1 = $[2];
        }
        return t1;
      }
    case FilterURI.AdType:
      {
        let t1;
        if ($[3] !== category.adTypes || $[4] !== showBadgeNew || $[5] !== trackSearchConversion) {
          t1 = <AdTypeSelector adTypes={category.adTypes} showBadgeNew={showBadgeNew} trackSearchConversion={trackSearchConversion} />;
          $[3] = category.adTypes;
          $[4] = showBadgeNew;
          $[5] = trackSearchConversion;
          $[6] = t1;
        } else {
          t1 = $[6];
        }
        return t1;
      }
    case FilterURI.ItemUrgent:
      {
        let t1;
        if ($[7] !== trackSearchConversion) {
          t1 = <UrgentSelector trackSearchConversion={trackSearchConversion} />;
          $[7] = trackSearchConversion;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
    case FilterURI.QuerySubjectOnly:
      {
        let t1;
        if ($[9] !== showBadgeNew || $[10] !== trackSearchConversion) {
          t1 = <QSOSelector showBadgeNew={showBadgeNew} trackSearchConversion={trackSearchConversion} />;
          $[9] = showBadgeNew;
          $[10] = trackSearchConversion;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
  }
  switch (filter.type) {
    case "bool":
      {
        const t1 = activeFilters[filter.queryString];
        let t2;
        if ($[12] !== filter || $[13] !== onFilterSelected || $[14] !== showBadgeNew || $[15] !== t1) {
          t2 = <BoolSelector filter={filter} initialValue={t1} showBadgeNew={showBadgeNew} onSelect={onFilterSelected} />;
          $[12] = filter;
          $[13] = onFilterSelected;
          $[14] = showBadgeNew;
          $[15] = t1;
          $[16] = t2;
        } else {
          t2 = $[16];
        }
        return t2;
      }
    case "list":
      {
        let t1;
        if ($[17] !== activeFilters || $[18] !== filter || $[19] !== filterStore) {
          t1 = extractDependencyValues(filter, filterStore, activeFilters);
          $[17] = activeFilters;
          $[18] = filter;
          $[19] = filterStore;
          $[20] = t1;
        } else {
          t1 = $[20];
        }
        const dependenciesValues = t1;
        if (filter.searchable || filter.multiSelection) {
          const t2 = activeFilters[filter.queryString];
          let t3;
          if ($[21] !== category || $[22] !== dependenciesValues || $[23] !== filter || $[24] !== onFilterSelected || $[25] !== showBadgeNew || $[26] !== t2) {
            t3 = <FilterableListSelector filter={filter} category={category} initialValue={t2} dependenciesValues={dependenciesValues} showBadgeNew={showBadgeNew} onSelect={onFilterSelected} />;
            $[21] = category;
            $[22] = dependenciesValues;
            $[23] = filter;
            $[24] = onFilterSelected;
            $[25] = showBadgeNew;
            $[26] = t2;
            $[27] = t3;
          } else {
            t3 = $[27];
          }
          return t3;
        }
        const t2 = activeFilters[filter.queryString];
        let t3;
        if ($[28] !== category || $[29] !== dependenciesValues || $[30] !== filter || $[31] !== onFilterSelected || $[32] !== showBadgeNew || $[33] !== t2) {
          t3 = <ListSelector filter={filter} category={category} initialValue={t2} dependenciesValues={dependenciesValues} showBadgeNew={showBadgeNew} onSelect={onFilterSelected} />;
          $[28] = category;
          $[29] = dependenciesValues;
          $[30] = filter;
          $[31] = onFilterSelected;
          $[32] = showBadgeNew;
          $[33] = t2;
          $[34] = t3;
        } else {
          t3 = $[34];
        }
        return t3;
      }
    case "range":
      {
        const t1 = activeFilters[filter.min.queryString];
        const t2 = activeFilters[filter.max.queryString];
        let t3;
        if ($[35] !== t1 || $[36] !== t2) {
          t3 = {
            min: t1,
            max: t2
          };
          $[35] = t1;
          $[36] = t2;
          $[37] = t3;
        } else {
          t3 = $[37];
        }
        let t4;
        if ($[38] !== filter || $[39] !== onFilterSelected || $[40] !== showBadgeNew || $[41] !== t3) {
          t4 = <RangeSelector filter={filter} initialValues={t3} showBadgeNew={showBadgeNew} onSelect={onFilterSelected} />;
          $[38] = filter;
          $[39] = onFilterSelected;
          $[40] = showBadgeNew;
          $[41] = t3;
          $[42] = t4;
        } else {
          t4 = $[42];
        }
        return t4;
      }
    default:
      {
        return null;
      }
  }
};